export default "__VITE_ASSET__CgzBQQZI__"